import { useEffect, useState } from "react";
import Silk from "./Silk";

interface SilkBackdropProps {
  /** Blend strength over the underlying gradient (0–1). */
  opacity?: number;
  className?: string;
}

/**
 * Drop-in animated silk layer for a `relative` green section. Sits behind
 * content (z-0) and blends over the section's existing gradient. Renders
 * nothing when the user prefers reduced motion.
 */
const SilkBackdrop = ({ opacity = 0.55, className = "" }: SilkBackdropProps) => {
  const [reducedMotion, setReducedMotion] = useState(false);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
    setReducedMotion(mq.matches);
    const handler = (e: MediaQueryListEvent) => setReducedMotion(e.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);

  if (reducedMotion) return null;

  return (
    <div
      aria-hidden="true"
      className={`absolute inset-0 z-0 overflow-hidden pointer-events-none transition-opacity duration-700 ease-out ${className}`}
      style={{ opacity: ready ? opacity : 0 }}
    >
      <Silk
        speed={2.7}
        scale={0.7}
        color="#1F3D3B"
        noiseIntensity={0.6}
        rotation={1.64}
        onReady={() => setReady(true)}
      />
    </div>
  );
};

export default SilkBackdrop;
